import { render, staticRenderFns } from "./ObbUploader.vue?vue&type=template&id=4802f21f"
import script from "./ObbUploader.vue?vue&type=script&lang=js"
export * from "./ObbUploader.vue?vue&type=script&lang=js"
import style0 from "./ObbUploader.vue?vue&type=style&index=0&id=4802f21f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports